import { createFileRoute, Link, Outlet, useLocation } from '@tanstack/react-router';
import { Layout } from 'antd';
import { Copyright } from '@/features/layout/components/Copyright';
import { useSistemaQuery } from '@/features/sistema/api';
import style from '../auth/style.module.scss';

export const Route = createFileRoute('/admin/auth')({
    component: AuthAdminLayout,
});

const topBarInfo = {
    '/auth/cadastro': {
        d: 'Entre',
        l: '/auth/login',
        t: 'Já possui uma conta?',
    },
    '/auth/login': {
        d: 'Criar agora',
        l: '/auth/cadastro',
        t: 'Ainda não tem conta?',
    },
};

function AuthAdminLayout() {
    const location = useLocation();

    const { sistema } = useSistemaQuery();

    return (
        <Layout>
            <Layout.Content>
                <div
                    className='flex min-h-[100vh] w-full shrink-0 flex-col items-center bg-cover bg-center bg-no-repeat shadow-md'
                    style={{
                        backgroundColor: sistema?.layout.sic_cor_primaria,
                        color: 'white',
                    }}
                >
                    <div className='mb-[7vh] flex h-16 w-full flex-row items-center justify-between border-b-2 border-solid border-gray-100 bg-white p-7'>
                        <div className={style.logoContainer}>
                            <div className={style.logo}>
                                <Link to='/admin/auth/login'>
                                    <img
                                        alt={sistema?.sis_nome_sistema}
                                        className='mr-2'
                                        src={
                                            sistema?.sis_logotipo
                                                ? sistema.sis_logotipo
                                                : 'resources/images/logo.svg'
                                        }
                                    />
                                </Link>
                                <div
                                    className={style.name}
                                    style={{ color: sistema?.layout.sic_cor_sistema_nome }}
                                >
                                    {sistema?.sis_nome_sistema}
                                </div>
                            </div>
                        </div>

                        <div className='d-none d-sm-block'>
                            <span className='mr-2'>{topBarInfo[location.pathname]?.t}</span>
                            <Link
                                className='kit__utils__link text-base'
                                to={topBarInfo[location.pathname]?.l}
                            >
                                {topBarInfo[location.pathname]?.d}
                            </Link>
                        </div>
                    </div>

                    <div className={style.containerInner}>
                        <Outlet />
                    </div>

                    <Copyright isAdmin={true} />
                </div>
            </Layout.Content>
        </Layout>
    );
}
